// extracted by mini-css-extract-plugin
export default {"text":"ConsignmentEditHeader_text__xyknS"};